module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"title":"Распечатать схему проезда на площадку разгрузки для:","confirm":"Подтвердить и распечатать","cancel":"Это не я. Отменить"}}')
  delete Component.options._Ctor
}
